import Color from './color';

export default class PCCSBright extends Color {
    static diverse() {
        return [
            '#f19896',
            '#ffa787',
            '#ffbe71',
            '#f2d96e',
            '#c7d36d',
            '#85ce9e',
            '#62c0b5',
            '#5bafc4',
            '#6c9ac5',
            '#9091c3',
            '#b088b5',
            '#d98ea5',
        ];
    }
}
